export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://healthcare-backend-195649616070.us-central1.run.app";
export const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL || "wss://healthcare-backend-195649616070.us-central1.run.app";



